import React, { useMemo, useRef } from "react";
import {
  Content,
  NameContent,
  NameWrapper,
  SearchBox,
  SearchIcon,
  SearchInput,
  SearchItem,
  SectionTitle,
} from "./styles";
import {
  StyledParagraph,
  StyledText,
  StyledTitle,
} from "../CustomAntdComponents/Typography";
import { useStore } from "../../store/global/appStore";
import { FixedSizeList as List } from "react-window";
import { ReactComponent as CircleIcon } from "../../assets/images/circle.svg";
import { ReactComponent as LocationIcon } from "../../assets/images/location.svg";

const suggestedSearches: RoadRoute[] = [
  // {
  //   TerminalId: 921,
  //   TerminalName: "Abia (Aba)",
  //   IsDeparture: true,
  //   IsArrival: true,
  // },
  // {
  //   TerminalId: 924,
  //   TerminalName: "Anambra (Awka)",
  //   IsDeparture: true,
  //   IsArrival: true,
  // },
  // {
  //   TerminalId: 926,
  //   TerminalName: "Delta (Asaba-Onitsha)",
  //   IsDeparture: true,
  //   IsArrival: true,
  // },
  // {
  //   TerminalId: 931,
  //   TerminalName: "Enugu (Enugu)",
  //   IsDeparture: true,
  //   IsArrival: true,
  // },
  // {
  //   TerminalId: 941,
  //   TerminalName: "Lagos (Ejigbo)",
  //   IsDeparture: true,
  //   IsArrival: true,
  // },
  // {
  //   TerminalId: 937,
  //   TerminalName: "Lagos (Okota)",
  //   IsDeparture: true,
  //   IsArrival: true,
  // },
  // {
  //   TerminalId: 945,
  //   TerminalName: "Lagos (Ajah)",
  //   IsDeparture: true,
  //   IsArrival: true,
  // },
  // {
  //   TerminalId: 920,
  //   TerminalName: "Abia (Umuahia)",
  //   IsDeparture: true,
  //   IsArrival: true,
  // },
  // {
  //   TerminalId: 934,
  //   TerminalName: "Imo (Orlu)",
  //   IsDeparture: true,
  //   IsArrival: true,
  // },
  // {
  //   TerminalId: 932,
  //   TerminalName: "Imo (Owerri)",
  //   IsDeparture: true,
  //   IsArrival: true,
  // },
];

const SelectRoadSearches = ({
  onSelect,
  searchText,
  setSearchText,
  options,
  height = 500,
  limitSuggestionHeight,
  mode,
  isMobileView = false,
}: {
  limitSuggestionHeight?: boolean;
  height?: number;
  onSelect: (terminalId: string) => void;
  searchText: string;
  setSearchText?: (value: string) => void;
  options?: SelectOption[];
  mode: string;
  isMobileView?: boolean;
}) => {
  const searchRef = useRef<HTMLInputElement>(null);
  const isFrom = mode === "from";

  const popoverTitle = isFrom
    ? "Where are you departing from?"
    : "Where is your destination?";

  const { roadRoutes } = useStore();

  const baseOptions = useMemo(() => {
    if (options?.length) return options;

    return roadRoutes.map((route) => ({
      label: route.TerminalName,
      value: route.TerminalId.toString(),
    }));
  }, [options, roadRoutes]);

  const filteredOptions = useMemo(() => {
    const textLower = searchText.toLowerCase();

    return baseOptions.filter((option) =>
      option.label.toLowerCase().includes(textLower)
    );
  }, [baseOptions, searchText]);

  const filteredLength = filteredOptions.length;
  const suggestionHeight = limitSuggestionHeight ? `${height}px` : "100%";
  const listHeight = limitSuggestionHeight ? height - 48 : height;

  return (
    <Content height={suggestionHeight}>
      <SectionTitle>
        <StyledText size="16px">{popoverTitle}</StyledText>
      </SectionTitle>

      {isMobileView && (
        <SearchBox>
          <SearchIcon>{isFrom ? <CircleIcon /> : <LocationIcon />}</SearchIcon>

          <SearchInput
            ref={searchRef}
            value={searchText}
            onChange={(e) => setSearchText?.(e.target.value)}
            placeholder={isFrom ? "From:" : "To:"}
            aria-label={
              isFrom
                ? "Search departure terminal"
                : "Search destination terminal"
            }
          />
        </SearchBox>
      )}

      {searchText && filteredLength === 0 && (
        <SectionTitle>
          <StyledParagraph align="center" size="normal">
            No results found.
          </StyledParagraph>
        </SectionTitle>
      )}

      {searchText ? (
        <List height={listHeight} itemCount={filteredLength} itemSize={66} width="100%">
          {({ index, style }) => {
            const option = filteredOptions[index];

            return (
              <div style={{ ...style, paddingLeft: "16px", paddingRight: "16px" }}>
                <SearchItem onClick={() => onSelect(option.value.toString())}>
                  <NameWrapper>
                    <NameContent>
                      <StyledTitle level={5}>{option.label}</StyledTitle>
                      <StyledText>Road terminal</StyledText>
                    </NameContent>
                  </NameWrapper>
                </SearchItem>
              </div>
            );
          }}
        </List>
      ) : (
        <>
          {suggestedSearches.map((search) => (
            <SearchItem
              key={search.TerminalId}
              onClick={() => onSelect(search.TerminalId.toString())}
            >
              <NameWrapper>
                <NameContent>
                  <StyledTitle level={5}>{search.TerminalName}</StyledTitle>
                  <StyledText>Road terminal</StyledText>
                </NameContent>
              </NameWrapper>
            </SearchItem>
          ))}
        </>
      )}
    </Content>
  );
};

export default SelectRoadSearches;